import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SelectAccountsPageRoutingModule } from './select-accounts-routing.module';

import { SelectAccountsPage } from './select-accounts.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SelectAccountsPageRoutingModule
  ],
  declarations: [SelectAccountsPage]
})
export class SelectAccountsPageModule {}
